module.exports = __webpack_public_path__ + "static/media/people.f17dddc3.svg";